<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        
        <Detail :header="header" :values="values" @edit="edit"/>
        <TabMenu :model="nestedRouteItems" />
        <br />
        <router-view v-if="contact1" :contact="contact1" />
      </div>
    </div>

    <ContactForm
      :reload="reloadContactForm"
      :contactToEdit="contactToEdit"
      :contactForm="contactDialog"
      :disabledArr="contactDisabledArr"
      @hide-form-dialog="contactDialog = false"
      @submit-contact-form=savedContact
    />
  </div>
</template>

<script>
import ContactService from "@/service/ContactService";
import CustomerService from "@/service/CustomerService";

import Detail from "@/mbp/universalComponents/Detail.vue";
import ContactForm from '@/mbp/universalComponents/contact/contactForm'
import BreadcrumbRecordMixin from '../BreadcrumbRecordMixin'

export default {
  mixins: [BreadcrumbRecordMixin],
  components: {
    Detail,
    ContactForm
  },
  data() {
    return {
      contactService: new ContactService(),
      customerService: new CustomerService(),
      header: "Contact Details",
      nestedRouteItems: [
        {
          label: "Info",
          icon: 'pi pi-info-circle',
          to: `/contacts/${this.$route.params.contactId}/detail`,
        },
        // {
        //   label: "History",
        //   icon: 'pi pi-inbox',
        //   to: `/contacts/${this.$route.params.contactId}/history`,
        // },
      ],
      contact1: {},
      values: [],
      contactDialog: false,
      contactDisabledArr: [],
      contactToEdit: {},
      reloadContactForm: 0
    };
  },
  computed: {
    contact: {
      set(val) {
        if (val && val.contactId) {
          this.contact1 = val
        }
      },
      get() {
        return this.$store.getters['contacts/getContactDetailsForTab'] && this.$store.getters['contacts/getContactDetailsForTab'].contactId ? this.$store.getters['contacts/getContactDetailsForTab'] : this.contact1
      }
    },
    breadcrumbRecordLabel() {
      return this.contact && this.contact.contactName ? this.contact.contactName : ''
    }
  },
  created() {
    
    // this.setValues()

    if (!(this.contact && this.contact.contactId)) {
      this.getContact(this.$route.params.contactId)
      this.getContactHistory(this.$route.params.contactId)
    } else {
      this.$store.dispatch('contacts/setContactDetailsForTab', this.contact)
      this.setValues()
    }
  },
  watch: {
    contactDialog(val) {
      this.reloadContactForm++
    },
    contact(val) {
      
      if (val && val.contactId) {
        this.$store.dispatch('contacts/setContactDetailsForTab', val)
        this.setValues()
      }
    }
  },
  methods: {
    savedContact({ contact, duplicateContact, duplicateToSend }) {
      
      this.contactToEdit = {}
      this.contactDialog = false
      
      // No neeed for duplciate while editing
      // if (duplicateToSend) {
      //   this.duplicateToSend = duplicateToSend
      //   this.duplicateContact = duplicateContact
      //   this.duplicateDialog = true
      // }

      this.getContact(this.$route.params.contactId)
    },
    setValues() {
      if (
        this.contact
      ) {
        this.values = [
          {
            title: "Name:",
            description: this.contact.contactName
          },
          {
            title: "Customer",
            description: this.contact.custName
          },
          {
            title: "Code:",
            description: this.contact.contactCode
          },
          null
        ]
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "contact not found.",
          life: 5000,
        })
      }
    },
    edit() {
      
      
      this.contactToEdit = this.contact
      this.contactDisabledArr = ['country']
      this.contactDialog = true
    },
    getContact(contactId) { 
      this.contactService
        .getContact(contactId)
        .then(data => this.contact = data)
        .catch(err => {
          
                
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while getting contact",
            life: 5000,
          })
        })
    },
    getContactHistory(contactId) {
      // this.ContactService
      //   .getContactHistory(contactId)
      //   .then(data => this.$store.dispatch('contacts/setContactHistorForTab', data))
      //   .catch(err => {
      //     
                
      //     this.$toast.add({
      //       severity: "error",
      //       summary: "Error",
      //       detail: "Error while getting contact History",
      //       life: 5000,
      //     })
      //   })
    }
  }
}
</script>

<style>

</style>